import storageService from './storageService';
import sessionStorageService from './sessionStorageService';
const CUSTOMER_STORAGE = 'customer_data_';
const CUSTOMER_STORAGE_VERSION = 'v4';
export const customerStorage = {
    getKey(dimensions) {
        if (dimensions) {
            const { brand, country } = dimensions;
            return `${brand}_${country}_${CUSTOMER_STORAGE_VERSION}_${CUSTOMER_STORAGE}`;
        }
        return `${CUSTOMER_STORAGE_VERSION}_${CUSTOMER_STORAGE}`;
    },
    getCustomerData(dimensions) {
        let customerData = null;
        try {
            customerData = JSON.parse(storageService.get(customerStorage.getKey(dimensions)) ?? '');
        }
        catch (error) {
            customerData = null;
        }
        return customerData ?? { postcode: '' };
    },
    setCustomerData(customerData, dimensions) {
        return storageService.set(customerStorage.getKey(dimensions), JSON.stringify(customerData));
    },
    setCustomerDataSession(customerData, dimensions) {
        return sessionStorageService.set(customerStorage.getKey(dimensions), JSON.stringify(customerData));
    },
    removeCustomerData(dimensions) {
        return storageService.remove(customerStorage.getKey(dimensions));
    },
    setPostcode(postcode, dimensions) {
        const customerData = this.getCustomerData(dimensions);
        if (customerData && customerData.postcode) {
            return;
        }
        else if (!customerData ||
            !customerData.postcode ||
            !customerData.selectedDealer) {
            this.setCustomerData({ ...customerData, postcode }, dimensions);
        }
    },
    getCustomerDataSession(dimensions) {
        let customerData = null;
        try {
            customerData = JSON.parse(sessionStorageService.get(customerStorage.getKey(dimensions)) ?? '');
        }
        catch (error) {
            customerData = null;
        }
        return customerData ?? { postcode: '' };
    },
    getPostcode(dimensions) {
        const customerData = this.getCustomerData(dimensions);
        return customerData?.postcode;
    },
};
export const getDimensionalCustomerStorage = (dimensions) => {
    return {
        ...customerStorage,
        getKey: () => customerStorage.getKey(dimensions),
        getCustomerData: () => customerStorage.getCustomerData(dimensions),
        getCustomerDataSession: () => customerStorage.getCustomerDataSession(dimensions),
        setCustomerData: (customerData) => customerStorage.setCustomerData(customerData, dimensions),
        setCustomerDataSession: (customerData) => customerStorage.setCustomerDataSession(customerData, dimensions),
        removeCustomerData: () => customerStorage.removeCustomerData(dimensions),
        setPostcode: (postcode) => customerStorage.setPostcode(postcode, dimensions),
        getPostcode: () => customerStorage.getPostcode(dimensions),
    };
};
//# sourceMappingURL=customerStorage.js.map